import React, { memo, useCallback, useContext, useState } from 'react';
import Pagination from '@components/Pagination';
import Select from '@components/Select';

import { FooterProps } from './types';
import { TableComponentsCommonPropsContext, TableStateContext } from '../context';

export const Foot: React.FC<FooterProps> = memo(() => {
    const [{ activePage = 1, pageSize = 10 }, setTableState] = useContext(TableStateContext),
        { onPageChange, table, totalItems, isAdministrator, totalPageOverride } = useContext(TableComponentsCommonPropsContext);

    const handlePageClick = useCallback(
        (page: number) => {
            table.setPageIndex(page - 1);
            setTableState((val) => {
                const newState = { ...val, activePage: page };
                onPageChange && onPageChange(newState);
                return newState;
            });
        },
        [onPageChange, setTableState, table],
    );

    const handlePageSizeChange = useCallback(
        (option: any) => {
            table.setPageSize(option.value);
            setTableState((val) => {
                const newState = { ...val, pageSize: option.value };
                onPageChange && onPageChange(newState);
                return newState;
            });
            setOptionValue(option);
        },
        [onPageChange, setTableState, table],
    );
    const options = [
        {
            label: '5',
            value: 5,
        },
        {
            label: '10',
            value: 10,
        },
        {
            label: '20',
            value: 20,
        },
        {
            label: '50',
            value: 50,
        },
        {
            label: '100',
            value: 100,
        },
        {
            label: '500',
            value: 500,
        },
    ];
    // Find the option that matches the current pageSize from context
    const currentOption = options.find(option => option.value === pageSize) || options.find(option => option.value === (isAdministrator ? 50 : 10));
    const [optionValue, setOptionValue] = useState(currentOption);

    // If we have a totalPageOverride, we need to calculate the effective totalItems to pass to the Pagination component
    // This ensures pagination respects the total pages limit
    const effectiveTotalItems = totalPageOverride !== undefined ? totalPageOverride * pageSize : totalItems;

    return (
        <div className="d-flex justify-content-center align-items-center pagination-wrapper">
            <Pagination onPageClick={handlePageClick} itemsPerPage={pageSize} activePage={activePage} totalItems={effectiveTotalItems} />
            <div className="pagination-size paging-size" style={{ marginRight: '5px' }}>
                <Select
                    isSearchable={false}
                    menuPlacement={'top'}
                    defaultValue={currentOption}
                    value={optionValue}
                    onChange={handlePageSizeChange}
                    styles={{
                        control: (base) => ({
                            ...base,
                            height: 30,
                            minHeight: 30,
                            fontSize: 12,
                        }),
                        dropdownIndicator: (base) => ({
                            ...base,
                            padding: 0,
                        }),
                    }}
                    options={options}
                />
            </div>
            <div className="form-text text-muted pl-1" style={{ marginLeft: '5px', paddingBottom: '5px' }}>
                Page <strong>{activePage}</strong> of{' '}
                <strong>{totalPageOverride !== undefined ? totalPageOverride : Math.ceil(totalItems / pageSize)}</strong>
            </div>
        </div>
    );
});

Foot.displayName = 'Foot';
